import React from 'react';
import type { IssueStatus } from './types';

const STATUS_CONFIG: Record<IssueStatus, { bg: string; text: string; label: string }> = {
  AUTO_FIXED:        { bg: 'bg-[#D1FAE5]', text: 'text-[#065F46]', label: '\u2705 Auto-Fixed' },
  AWAITING_DECISION: { bg: 'bg-[#FEF3C7]', text: 'text-[#92400E]', label: '\uD83D\uDFE1 Awaiting Decision' },
  FLAGGED:           { bg: 'bg-[#DBEAFE]', text: 'text-[#1E40AF]', label: '\uD83D\uDD35 Flagged' },
  CANNOT_RESOLVE:    { bg: 'bg-[#FEE2E2]', text: 'text-[#991B1B]', label: '\uD83D\uDD34 Cannot Resolve' },
};

interface IssueStatusBadgeProps {
  status: IssueStatus;
}

const IssueStatusBadge: React.FC<IssueStatusBadgeProps> = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.FLAGGED;
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-semibold whitespace-nowrap ${config.bg} ${config.text}`}>
      {config.label}
    </span>
  );
};

export default IssueStatusBadge;
